import { render, staticRenderFns } from "./ServiceproviderMyResource.vue?vue&type=template&id=145b1ecd&"
import script from "./ServiceproviderMyResource.vue?vue&type=script&lang=js&"
export * from "./ServiceproviderMyResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports